import React from 'react';
import OdezaAppStandalone from 'odeza-customer-chat-core/src/OdezaAppStandalone';
import {config} from './config';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {QUEUE_NAME_SCRIPPS_1_800, QUEUE_NAME_SCRIPPS_ESTIMATES} from "./constants";

function App() {
    return (
        <Router>
            <Switch>
				<Route path={process.env.PUBLIC_URL +"/estimates"}
					   render={(props) => (
						   <OdezaAppStandalone
							   {...props}
							   config={config}
							   startQueueName={QUEUE_NAME_SCRIPPS_ESTIMATES}
						   />
					   )}
				/>
                {/*--- Main\Default route ---*/}
				<Route path={process.env.PUBLIC_URL}
					   render={(props) => (
						   <OdezaAppStandalone
							   {...props}
							   config={config}
							   startQueueName={QUEUE_NAME_SCRIPPS_1_800}
						   />
					   )}
				/>
            </Switch>
        </Router>
    );
}

export default App;
